import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=f763f35c&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=f763f35c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f763f35c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f763f35c')) {
      api.createRecord('f763f35c', component.options)
    } else {
      api.reload('f763f35c', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=f763f35c&scoped=true&", function () {
      api.rerender('f763f35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k3GS74xCZplR/JS/comp/Paginate.vue"
export default component.exports